module.exports = __webpack_public_path__ + "img/api-token.049186f7.png";